// extracted by mini-css-extract-plugin
export default {"agritourismL2":"AgritourismL2_agritourismL2__5wb+L","grade":"AgritourismL2_grade__cpb6M","smallPiegraph":"AgritourismL2_smallPiegraph__Z2sq1"};